import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { UserProfileMacroRendererProps } from '../src/user-profile/UserProfileMacroRenderer.tsx';

export const UserProfileMacroHandler: LoadableType<UserProfileMacroRendererProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-UserProfileMacro" */ '../src/user-profile/UserProfileMacroRenderer.tsx'
				)
			).UserProfileMacroRenderer,
	});
